import request from '@/utils/request'
import { $t } from '@/i18n'

// 账户明细列表
export function withdrawList(params) {
  return request({
    url: '/mct_withdraw/v1',
    params
  })
}

// 账户明细列表导出
export function exportWithdrawList(params) {
  return request(
    {
      url: '/export/mct_withdraw/v1',
      params
    },
    {
      success: true,
      successMsg: $t('common.downloadBufferOK')
    }
  )
}

// 自动提现配置详情
export function getAutoWithdraw() {
  return request({
    url: `/mct_auto_withdraw_config/v1`
  })
}

// 账户明细详情
export function withdrawDetail(id) {
  return request({
    url: `/mct_withdraw/detail/${ id }/v1`
  })
}

// 自动提现配置新增/修改
export function editAutoWithdraw(data) {
  return request({
    url: `/mct_auto_withdraw_config/v1`,
    method: 'PUT',
    data
  })
}

// 提现账号列表
export function withdrawAccountList() {
  return request({
    url: '/withdraw_config/v1'
  })
}

// 提现记录列表上方数据
export function withdrawTop() {
  return request({
    url: '/mct_withdraw/top/v1'
  })
}

// 提现申请时提现信息获取
export function withdrawMessage() {
  return request({
    url: '/mct_withdraw/message/v1'
  })
}

// 提现申请
export function applyWithdraw(data) {
  return request({
    url: '/mct_withdraw/v1',
    method: 'POST',
    data
  })
}

// 短信验证码
export function sendWithdrawMessage(params) {
  return request({
    url: '/mct_withdraw/sendMessage/v1',
    params
  }, {
    success: true,
    successMsg: '发送成功'
  })
}

// 获取短信验证码
export function sendMessage() {
  return request({
    url: '/mct_withdraw/sendMessage/v1'
  })
}

// 获取银行列表
export function bankList() {
  return request({
    url: '/sys_bank/v1'
  })
}

// 开户支行信息列表
export function accountBranchList(params) {
  return request({
    url: '/banking_outlets/v1',
    params
  })
}

// 提现配置新增
export function addWithdrawConfig(data) {
  return request(
    {
      url: '/withdraw_config/v1',
      method: 'POST',
      data
    },
    {
      success: true,
      successMsg: '新增成功'
    }
  )
}

// 查看账户完整验证码验证
export function sendWithdrawFullMessage(data) {
  return request({
    url: '/withdraw_config/message/v1',
    method: 'PUT',
    data
  })
}

//获取运营商户
export function getMerchantList(data) {
  return request({
    url: '/manager/mct',
    method: 'POST',
    data
  })
}
